export default __webpack_public_path__ + "static/media/vagrant.3ec531c5.svg";